import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXAppNewBusiness_SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        {
          id: 1,
          text01: "CityX Transporentnost",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
        {
          id: 2,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
        {
          id: 3,
          text01:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          text02:
            "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.",
        },
      ],
    };
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className=" clearfix">
              <div className="themesflat-headings style-1 clearfix">
                <div className="sup-heading">CityX App</div>
                <h5 className="title">
                  Zašto i kako uključiti lokalnu tvrtku u CityX sustav?
                </h5>
                <div className="sep has-width w80 accent-bg margin-top-20 margin-bottom-30 clearfix" />
                <p className="">
                  Povežite se sa svojim sugrađanima, proširite bazu klijenata,
                  digitalizirajte poslovanje i ubrzajte procese s našim
                  naprednim digitalnim rješenjima! Saznajte kako postati
                  konkurentniji kroz sustav CITYX!
                  <br />
                  CITYX je namijenjen svakoj tvrtki koja ima ponudu za građane,
                  posebice školama stranih jezika, lokalnim distribucijama
                  energenata, školama plesa, teretanama ili fitnessima,
                  sportskim klubovima ili likovnim radionicama. U našem
                  individualnom pristupu svakom klijentu, account manager koji
                  se brine o vašem iskustvu suradnje sa CityX voditi će proces
                  implementacije koji ovisno o paketu usluga traje između pet i
                  dvadeset dana.
                </p>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <p style={{ padding: "0px" }}>
              <iframe
                src="https://forms.monday.com/forms/embed/3699c1114b3775c5b4370be9337f7ad4?r=use1"
                width={"100%"}
                style={{
                  width: "200%",
                  height: "1000px",
                }}
              ></iframe>
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="">
            <div className="item">
              <div className="inner">
                <p style={{ color: "gray" }}>
                  <h5>Kako napisati tekst "O nama"</h5>
                  <br />
                  <br />
                  PRIMJER: OPG PERIĆ
                  <br />
                  Mi smo veće obiteljsko poljoprivredno gospodarstvo, smješteno
                  na rubnom dijelu grada Zagreba. Primarno se bavimo uzgojem
                  batata, a uzgajamo još i tradicionalno sezonsko povrće kao što
                  su krumpir, rajčice, paprika, luk, krastavci, mrkva i cikla.
                  <br />
                  <br />
                  OPG je osnovan je 2013. godine na poljoprivrednim površinama u
                  vlastitim posjedu. Svaki proizvod nosi eko certifikat, raste u
                  vrtovima i plastenicima površine više od 10 hektara. Samo
                  poljoprivrednici znaju koliko truda i rada zahtjeva ovako
                  velik vrt, svaki najmanji detalj je jednako važan. <br />
                  Veće gospodarstvo poput našeg, koje svoje površine
                  prilagođava, iskorištava i čuva na ekološki način, najavljuje
                  novu eru zdrave poljoprivrede. Do prije 10 godina takva ideja
                  se smatrala neizvedivom a eko proizvod smatrao se skupom
                  hranom. Mi smo, vjerujemo, razbili takve predrasude i pokazali
                  kako upornost i vjera u bolje jamče i- uspjeh. :-)
                  <br />
                  <br />
                  Naime, da je naš krumpir zlata vrijedan dokazalo se i prije
                  dvije godine kada smo osvojili nagradu “Agro Oskar 2020.” u
                  organizaciji Večernjeg lista, i to u kategoriji najboljeg
                  proizvođača eko krumpira. <br />
                  Naše proizvode moguće je kupiti putem webshopa, direktnim
                  pozivom/emailom ili osobno kod nas na gospodarstvu. Naša
                  ponuda uključuje pakiranja od 1kg, 2 kg, 5 kg, 10 kg i 20kg
                  (krumpir), 1kg i 2 kg (paprika)…
                  <br />
                  <br />
                  Tekst bi trebao uključivati odgovore na sljedeća pitanja:
                  <br />
                  Tko smo?
                  <br />
                  Što proizvodimo?/Eko prozivodnja?
                  <br />
                  Što se sve nalazi u ponudi? (pakiranja)
                  <br />
                  Nagrade za proizvode (ako postoje)
                  <br />
                  Posebnosti u odnosu na druge proizvođače
                  <br />
                  Kanali prodaje
                  <br />
                  <br />
                  Poželjni su i detaljniji opisi i način na koji mislite da bi
                  se najbolje prezentirali kupcima. ;-)
                </p>
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXAppNewBusiness_SiteContent;
